import { render, staticRenderFns } from "./faceRecognitionLog.vue?vue&type=template&id=6d20bbc0&scoped=true&"
import script from "./faceRecognitionLog.vue?vue&type=script&lang=js&"
export * from "./faceRecognitionLog.vue?vue&type=script&lang=js&"
import style0 from "./faceRecognitionLog.vue?vue&type=style&index=0&id=6d20bbc0&scoped=true&lang=css&"
import style1 from "./faceRecognitionLog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20bbc0",
  null
  
)

export default component.exports